var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserSearchDialog',{attrs:{"value":_vm.value,"search-action":_vm.searchAction},on:{"input":_vm.hideDialog,"user-selected":_vm.emitUserSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }